var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('el-pagination',_vm._g(_vm._b({attrs:{"background":"","layout":"prev, pager, next","prev-text":"上一页","next-text":"下一页"}},'el-pagination',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }